import { getAudioPermission } from './getAudioPermission';
import { getVideoPermission } from './getVideoPermission';
import { hasAudioPermissions } from './hasAudioPermissions';
import { hasCameraPermission } from './hasCameraPermission';
import { hasMediaPermissions } from './hasMediaPermissions';
import { hasMicrophonePermission } from './hasMicrophonePermission';
import { hasCamera } from './mediaDevices/hasCamera';
import { hasMicrophone } from './mediaDevices/hasMicrophone';

export const permissions = {
  getAudioPermission,
  getVideoPermission,
  hasAudioPermissions,
  hasCameraPermission,
  hasMediaPermissions,
  hasMicrophonePermission,
  hasCamera,
  hasMicrophone,
};
